(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('DownloadController', DownloadController);

    DownloadController.$inject = ['$rootScope', '$localStorage', 'Principal', '$translate', '$log', '$state', 'DownloadService', '$sce', 'Auth'];

    function DownloadController($rootScope, $localStorage, Principal, $translate, $log, $state, DownloadService, $sce, Auth) {

        // VARIABLES
        var vm = this;

        vm.lang = $translate.use();

        // FUNCITONS DEFINITIONS
        vm.loaded = pageLoaded;
        vm.finishRegistration = finishRegistration;
        vm.preAuthorized = false;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            vm.headline = vm.dto.title[vm.lang];
            vm.text = $sce.trustAsHtml(vm.dto.description[vm.lang]);
        });

        getExhibitorAuthorities();

        return vm;

        // FUNCTIONS
        function pageLoaded() {
            return !!vm.dto;
        }

        function getExhibitorAuthorities() {
            Principal.identity().then(function(identity) {
                $log.debug('SummaryController | authorities', identity);
                if (identity.authorities.indexOf('PRE_AUTHORIZED') !== -1) {
                    vm.preAuthorized = true;
                }
                loadDownloadData();
            }, function() {
                $log.debug('SummaryController | ERROR IDENTITY', value);
            });
        }


        function loadDownloadData() {
            DownloadService.loadDownloadLabels().then(successLabels, error);
            DownloadService.loadDownloadDocuments().then(successDocuments, error);
        }

        function successLabels(response) {
            $log.debug("DownloadController | Fetching download dto", response.data);
            vm.dto = response.data;

            if (vm.preAuthorized) {
                vm.headline = vm.dto.pretitle[vm.lang];
                vm.text = $sce.trustAsHtml(vm.dto.predescription[vm.lang]);
            } else {
                vm.headline = vm.dto.title[vm.lang];
                vm.text = $sce.trustAsHtml(vm.dto.description[vm.lang]);
            }
        }

        function successDocuments(response) {
            $log.debug("DownloadController | Fetching download documents", response.data);
            vm.downloads = response.data;
        }

        function error(response) {
            $log.debug('DownloadController | ERROR:', data);
        }

        function back() {
            $log.debug('DownloadController | back');
            $window.history.back();
        }

        function finishRegistration() {
            Auth.logout();
            $state.go('home', {}, {reload: true, notify: true});
        }

    }
})();
